// extracted by mini-css-extract-plugin
export default {"card":"AnalyticsOverview_card__QXMUU"};